import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fatherLastName',
})
export class FatherLastNamePipe implements PipeTransform {

  transform(value: string): string {

    if (!value) return '';

    const partes = value.trim().split(' ');

    // Verifica se tem pelo menos nome e sobrenome
    if (partes.length >= 2) {
      // Retorna apenas o primeiro nome e o último sobrenome
      return partes[0] + ' ' + partes[partes.length - 1];
    }

    // Se não houver sobrenome, retorna o nome completo
    return value;
  }

  private capitalize(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

}
